// extracted by mini-css-extract-plugin
export default {"header":"Header_header__mtodi","pageWrap":"Header_pageWrap__5S76W"};